/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{width:100%;display:-webkit-box;display:flex;-webkit-box-flex:1;flex:1}[_nghost-%COMP%]   .sign-up-button[_ngcontent-%COMP%]{min-width:150px}"];
export { styles as styles };
//# sourceMappingURL=group-class-tile-states.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/home/live-class-revamp/group-class/group-class-tile/group-class-tile-states/group-class-tile-states.component.scss.shim.ngstyle.js
// module id = 1538
// module chunks = 27 28 29